import { LoggingService } from "../sdServices/loggingSvc";
import {
  WindowHeartbeatServiceImpl,
  open as WindowStatusOpen
} from "../../ShellCommon/eventModule/window-heartbeat-service";
import { LocalizationService } from "../../ShellCommon/localization/localization";
import { ContextServiceImpl } from "../sdServices/context/context-service";
import { ContextInternal } from "../sdServices/context/context";

export const recoveryStateName = "sdSystem.recovery";
export interface RecoveryPageParameters {
  contextId: string;
  fallbackState?: string;
}

export class RecoveryPage {
  private recoveryInProgressMessage: string;
  private unableToRecoverContext: boolean;
  // @ngInject
  constructor(
    private contextService: ContextServiceImpl,
    private windowsHeartbeatService: WindowHeartbeatServiceImpl,
    private $q: ng.IQService,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService & RecoveryPageParameters,
    private loggingService: LoggingService,
    sdLocalizationService: LocalizationService
  ) {
    this.recoveryInProgressMessage = sdLocalizationService.getLocalizedString(
      "ServiceDesk",
      "_RECOVERY_PAGE_RECOVERY_IN_PROGRESS_"
    );
  }

  $onInit() {
    this.recoverContext().catch((reason: any) => {
      this.loggingService.logError(reason);
      let fallbackState = this.$stateParams.fallbackState;
      if (fallbackState) {
        this.loggingService.logWarning(`Going to fallback state ${fallbackState}`);
        this.$state.go(fallbackState);
      }
      this.unableToRecoverContext = true;
    });
  }

  private recoverContext(): ng.IPromise<ContextInternal> {
    let deferal = this.$q.defer<ContextInternal>();
    this.contextService.context(this.$stateParams.contextId).then((recoveredContext: ContextInternal) => {
      if (!recoveredContext) {
        return deferal.reject(`Unable to find context '${this.$stateParams.contextId}' to restore.`);
      }

      if (recoveredContext.status === WindowStatusOpen) {
        return deferal.reject(`Cannot restore a context that is still open`);
      }

      // transition to the same state as was previously available
      let destinationState = this.$state.get(recoveredContext.stateName);
      if (!destinationState) {
        return deferal.reject(`Unable to find state '${recoveredContext.stateName}' to restore to.`);
      }

      this.contextService.recoverContext(recoveredContext.id);

      let stateOptions: ng.ui.IStateOptions = {
        location: "replace",
        inherit: true,
        notify: true,
        reload: true
      };

      this.$state.go(destinationState, recoveredContext.stateParameters, stateOptions).then(() => {
        this.loggingService.logInfo(`Restored window for state: ${recoveredContext.stateName}`);
        this.contextService.clearSerializedContext(recoveredContext);
      });

      return deferal.resolve(this.contextService.current);
    });
    return deferal.promise;
  }
}
